<style lang="scss" scoped>
  .collecting {
    min-height: 100px;
  }
  table {
    table-layout: fixed;
    width: 100%
  }
  .wrap {
    word-wrap: break-word;
  }
</style>


<template>
  <div>
    <div class="table-container">
      <div class="collecting" v-if="collecting">
        Waiting for more data...
      </div>
      <c-sorted-table :values="values" v-else class="table">
        <thead>
          <tr>
            <th><c-sort-link name="node">Node Variable</c-sort-link></th>
            <th class="wrap"><c-sort-link name="data">Data</c-sort-link></th>
            <th><c-sort-link name="created">Created</c-sort-link></th>
            <th><c-sort-link name="ingested">Ingested</c-sort-link></th>
          </tr>
        </thead>
        <template #body="sort">
          <tbody>
            <tr v-for="row in sort.values" :key="row.row">
              <td>{{row.node}}</td>
              <td class="wrap">{{row.data}}</td>
              <td>{{row.created}}</td>
              <td>{{row.ingested}}</td>
            </tr>
          </tbody>
        </template>
      </c-sorted-table>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: 'lon',
  props: ['diode', 'events'],
  data() {
    return {
      table: {}
    };
  },
  computed: {
    collecting() {
      return !this.table || Object.keys(this.table).length === 0;
    },
    values() {
      return Object.values(this.table);
    }
  },
  watch: {
    // clear out table when diode changes
    diode() {
      this.$set(this, 'table', {});
    },
    // when events change aggregate them into table collection
    events() {
      this.events.forEach(event => {
          const node = event.payload.NVSelector;
          const data = event.payload.Data;
          let created = parseInt(event.created);
          let ingested = parseInt(event.ingested);
          ingested = moment(ingested).format('YYYY-MM-DD HH:mm:ss');
          created = moment(created).format('YYYY-MM-DD HH:mm:ss');
          this.$set(this.table, node, {node, data, created, ingested});
        });
    }
  }
};
</script>
